import yup from 'utils/yup';

export const initialCaptionFormData = {
  caption: '',
};

export const captionFormValidationSchema = yup.object().shape({
  caption: yup.string().required('Please write a caption'),
});

export const initialBreakFormData = {
  breakType: null,
};

export const breakFormValidationSchema = yup.object().shape({});
